import React from 'react'

interface CustomLoaderProps {
  size?: number
  minHeight?: string
}

export function CustomLoader({ size = 80, minHeight = '60vh' }: CustomLoaderProps) {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight,
      }}
    >
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <img
        src="/no_text_logo.svg"
        alt="Loading..."
        style={{
          width: size,
          height: size,
          animation: 'spin 1s linear infinite',
          transformOrigin: 'center center',
        }}
      />
    </div>
  )
}
